var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-selected-chat"},[_c('i',{staticClass:"el-icon-chat-dot-round"}),_c('p',[_vm._v("Select a chat to view the conversation.")])])
}]

export { render, staticRenderFns }